import { Col, Menu, Row } from "antd";
import { DownOutlined, EllipsisOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";

import { Drawer } from "@material-ui/core";
import Logo from "../assets/opis-logo.svg";
import { MenuOutlined } from "@ant-design/icons";
import Radium from "radium";
import SliderSection from "./SliderSection";
import { SwiperSlide } from "swiper/react";
import dashboard from "../assets/opis-dashboard.png";
import discord from "../assets/discord.svg";
import facebook from "../assets/facebook-white.svg";
import green from "../assets/rectangle-green.svg";
import img1 from "../assets/desafios-eventos.svg";
import img2 from "../assets/finanzas-regenerativas.svg";
import img3 from "../assets/fidelizacion-lealtad.svg";
import instagram from "../assets/instagram.svg";
import membership from "../assets/membership-card.svg";
import metamask from "../assets/metamask.svg";
import perfilDemo from "../assets/perfil-regenerador-demo.png";
import plus from "../assets/plus.svg";
import purple from "../assets/rectangle-purple.svg";
import { useMoralis } from "react-moralis";

const APIKEY = process.env.REACT_APP_MAGIC_APIKEY;

function SignedOut() {
  const { authenticate, authError, isAuthenticating } = useMoralis();
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const priceRef = useRef();
  const nftRef = useRef();
  const winRef = useRef();

  const customNodeOptions = {
    rpcUrl: "https://rpc-mumbai.maticvigil.com/v1/0fcf175a341230e99aa167effa08019b483e2627", // Polygon RPC URL
    chainId: 80001, // Polygon chain id
  };

  //Magic Authentication
  const handleCustomLogin = async (e) => {
    e.preventDefault();

    let options = {
      provider: "magicLink",
      email: email,
      apiKey: APIKEY, // Enter API key from Magic Dashboard https://dashboard.magic.link/
      network: customNodeOptions,
    };
    await authenticate(options).then((user) => {
      // save the email and provider to User object, optionally check if already set
      user.set("email", email);
      user.save();
    });
  };

  function setErrorMessage(e) {
    if (e.includes("email")) return "Por favor, ingresa un correo";
    else return "Ups! Ha ocurrido un error";
  }

  const ListItem = ({ img, p, span, key, discount, free }) => {
    return (
      <section style={styles.listItem} key={key}>
        <div style={styles.listItem.container}>
          <img
            src={img}
            alt={p}
            style={free ? styles.listItem.container.imgFree : styles.listItem.container.img}
          />
          <div style={styles.listItem.container.div}>
            <p style={styles.listItem.container.div.p}>{p}</p>
            <span style={styles.listItem.container.div.span}>{span}</span>
          </div>
        </div>
        {discount && <span style={styles.listItem.discount}>{discount}</span>}
      </section>
    );
  };

  const PremiumPlan = ({ name, price, text, key, data }) => {
    return (
      <Col xs={24} sm={24} md={24} lg={9} xl={9} xxl={9} key={key} style={styles.premiumPlan}>
        <section style={styles.premiumPlan.plan}>
          <div style={styles.premiumPlan.plan.div}>
            <h3 style={styles.premiumPlan.plan.div.h3}>{name}</h3>
            <EllipsisOutlined style={{ fontSize: "24px" }} />
          </div>
          <div style={styles.premiumPlan.plan.div}>
            <p style={styles.premiumPlan.plan.div.p}>
              Desde <span style={styles.premiumPlan.plan.div.p.span}>${price}</span> CLP
              <DownOutlined style={{ marginLeft: "24px" }} />
            </p>
          </div>
        </section>
        <p style={styles.premiumPlan.p}>Plan {text} +</p>

        <section style={styles.premiumPlan.itemsContainer}>
          {data.map(({ img, p, span, discount }) => (
            <ListItem img={img} p={p} span={span} key={p} discount={discount} />
          ))}
        </section>
      </Col>
    );
  };

  const images = [Logo, Logo, Logo, Logo, Logo, plus, plus, plus, plus];

  const dataEarn = [
    { p: "Desafíos y Eventos", span: "Con propósito", img: img1 },
    { p: "Finanzas Regenerativas", span: "Carbono neutro", img: img2 },
    {
      p: "Fidelización y Lealtad",
      span: "Responsabilidad Social Ambiental, Económica y Deportiva",
      img: img3,
    },
    { p: "Capital Social", span: "Desarrollo e inclusión", img: img3 },
    { p: "NFTs con Valor", span: "Colecciones", img: img3 },
  ];
  const free = [
    { p: "Completar desafíos", span: "Limitado 1 OPIS x desafío", img: green },
    { p: "Desafiar amigos", span: "Premios y tablas de posiciones", img: green },
    { p: "Eco vitrina", span: "Ofertas", img: green },
    { p: "Comunidad OPIS", span: "Discord", img: purple },
    { p: "Soprte", span: "General", img: purple },
  ];
  const responsable = [
    { p: "Crear Desafíos o Eventos", span: "Mínimo 500.000 OPIS x desafío", img: img1 },
    { p: "Publicidad Comunitaria", span: "Generales de la comunidad", img: img2 },
    { p: "xxxxxxxxxxx", span: "xxxxxxxxxxx", img: img3 },
    { p: "Comunidad Privada", span: "Club de beneficios", img: img3 },
    {
      p: "Soporte",
      span: "Preferente",
      img: img3,
      discount: (
        <p style={styles.listItem.discount.p}>
          1.000.000 <span style={styles.listItem.discount.p.span}>OPIS</span>
        </p>
      ),
    },
  ];
  const proposito = [
    { p: "Desafíos", span: "xxxxxxxxxxxxxxxxxxxxx", discount: "-$154.50", img: img1 },
    { p: "Promoción Dedicada", span: "Exclusiva del desaío", discount: "-$40.50", img: img2 },
    { p: "Staking OPIS", span: "Retorno del impacto", discount: "-$70.00", img: img3 },
    { p: "Club VIP", span: "Beneficios exclusivos", discount: "-$70.00", img: img3 },
    {
      p: "Soporte dedicado",
      span: "24/7",
      discount: (
        <p style={styles.listItem.discount.p}>
          5.004.004 <span style={styles.listItem.discount.p.span}>OPIS</span>
        </p>
      ),
      img: img3,
    },
  ];
  const plans = [
    { name: "Responsable Prepago", price: "9.990", text: "gratis", data: responsable },
    { name: "Propósito Mensual", price: "49.990", text: "Responsable", data: proposito },
  ];

  const getItem = (label, key, icon, children, type) => ({ key, icon, children, label, type });
  const items = [
    getItem("Ganar", "/win"),
    getItem("Precios", "/price"),
    getItem("NFTs", "/nft"),
    getItem("Ingresar", "/login"),
  ];
  const handleClick = (key) => {
    if (key === "/win") scrollTo(winRef.current.offsetTop);
    else if (key === "/price") scrollTo(priceRef.current.offsetTop);
    else if (key === "/nft") scrollTo(nftRef.current.offsetTop);
    else if (key === "/login") scrollTo(0);
  };
  const scrollTo = (to) => {
    setOpen(false);
    window.scroll({ top: to, behavior: "smooth" });
  };

  return (
    <div
      style={{
        background: "linear-gradient(38deg, rgba(255,255,255,1) 70%, rgba(120,213,4,0.2) 100%)",
      }}
    >
      <Row>
        <Col span={24} style={styles.header}>
          <img alt="logo" src={Logo} />
          <nav>
            <ul style={styles.header.ul}>
              <li style={styles.header.ul.li} onClick={() => handleClick("/win")}>
                Ganar
              </li>
              <li style={styles.header.ul.li} onClick={() => handleClick("/price")}>
                Precios
              </li>
              <li style={styles.header.ul.li} onClick={() => handleClick("/nft")}>
                NFTs
              </li>
            </ul>
          </nav>

          <div style={styles.header.container}>
            <form onSubmit={handleCustomLogin}>
              <input
                style={styles.header.container.input}
                type="email"
                placeholder="Ingresar correo"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </form>

            <button style={styles.header.container.btnWeb3}>Ingreso Web3</button>
          </div>

          <div style={styles.header.mobileSection}>
            <MenuOutlined style={{ fontSize: "24px" }} onClick={() => setOpen(true)} />
            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
              <Menu
                onClick={({ key }) => handleClick(key)}
                items={items}
                defaultSelectedKeys={["/"]}
                mode="inline"
                style={{ minWidth: "60vw", padding: "16px" }}
              ></Menu>
            </Drawer>
          </div>
        </Col>
      </Row>

      <section style={styles}>
        <div style={styles.firstSection}>
          <h1 style={styles.firstSection.h1}>
            <span style={styles.firstSection.h1.span}>Regeneración</span> impulsada por la
            responsabilidad
          </h1>

          {isAuthenticating && <p style={styles.firstSection.success}>Iniciando...</p>}
          {authError && (
            <p style={styles.firstSection.error}>{setErrorMessage(authError.message)}</p>
          )}
          <form onSubmit={handleCustomLogin} style={styles.firstSection.form}>
            <input
              style={styles.firstSection.form.input}
              type="email"
              placeholder="Ingresar correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" style={styles.firstSection.form.button}>
              Regenerar
            </button>
          </form>
          <p style={styles.firstSection.p}>o</p>
          <button style={styles.firstSection.metamask}>
            MetaMask <img src={metamask} alt="metamask" width={30} />
          </button>
        </div>

        <div style={styles.secondSection}>
          <SliderSection
            sliderSectionStyle={{
              height: "fit-content",
              backgroundColor: "transparent",
              overflowX: "scroll",
            }}
            className="slider-sign-out"
          >
            {images.map((src, i) => (
              <SwiperSlide key={i} style={{ width: "fit-content" }}>
                <div key={i} style={styles.secondSection.imgContainer}>
                  <img src={src} alt="logo" style={styles.secondSection.imgContainer.img} />
                </div>
              </SwiperSlide>
            ))}
          </SliderSection>
        </div>

        <Row style={styles.thirdSection} ref={winRef}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} style={styles.thirdSection.col1}>
            <h1 style={styles.thirdSection.col1.h1}>
              <span style={styles.thirdSection.col1.h1.span}>Act</span> to Earn
            </h1>

            <p style={styles.thirdSection.col1.p}>
              <span style={styles.thirdSection.col1.p.span}>¡¡Actuar para Ganar!!</span> La nueva
              forma de regenerar tu entorno, acceder a beneficios e impulsar tu comunidad.
            </p>

            <button style={styles.thirdSection.col1.btn}>
              <img src={discord} alt="discord" width={40} />
              Únete a la comunidad OPIS DAO
            </button>

            <div style={styles.thirdSection.col1.links}>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <img src={instagram} alt="instagram" width={30} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <img src={facebook} alt="facebook" width={30} />
              </a>
            </div>
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} style={styles.thirdSection.col2}>
            <div style={styles.thirdSection.col2.div}>
              {dataEarn.map(({ img, p, span }, i) => (
                <ListItem img={img} p={p} span={span} i={i} />
              ))}
            </div>
          </Col>
        </Row>

        <Row style={styles.fourthSection}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
            <img src={perfilDemo} alt="perfil demo" />
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
            <section>
              <h1 style={styles.fourthSection.col2.h1}>
                <span style={styles.fourthSection.col2.h1.span}>Eco</span> Ansiedad
              </h1>
              <p style={styles.fourthSection.col2.p}>
                Mitigamos el temor crónico de un cataclismo ambiental.
              </p>
            </section>

            <section>
              <h1 style={styles.fourthSection.col2.h1}>
                <span style={styles.fourthSection.col2.h1.span}>Hiper</span> Inflación
              </h1>
              <p style={styles.fourthSection.col2.p}>
                Evitamos la evidente reducción de su patrimonio monetario.
              </p>
            </section>
          </Col>
        </Row>

        <Row style={styles.fifthSection} ref={priceRef}>
          <Col span={24}>
            <h1 style={styles.fifthSection.h1}>
              <span style={styles.fifthSection.h1.span}>Precios</span> Planes
            </h1>
          </Col>

          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6} style={styles.fifthSection.col1}>
            <h2 style={styles.fifthSection.col1.h2}>
              Gratis <span style={styles.fifthSection.col1.h2.span}>Regenerador</span>
            </h2>
            {free.map(({ p, span, img }) => (
              <ListItem p={p} span={span} img={img} key={p} free={true} />
            ))}
          </Col>

          {plans.map(({ name, price, text, data }) => (
            <PremiumPlan name={name} price={price} text={text} key={name} data={data} />
          ))}
        </Row>

        <Row style={styles.sixthSection} ref={nftRef}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} style={styles.sixthSection.col1}>
            <h1 style={styles.sixthSection.col1.h1}>
              Membresia <span style={styles.sixthSection.col1.h1.span}>NFTs</span>
            </h1>
            <p style={styles.sixthSection.col1.p}>
              Beneficos exclusivos para el portador.{" "}
              <span style={styles.sixthSection.col1.p.span}>
                Membresia de por vida (Edición limitada a 1.000 uni.)
              </span>
            </p>

            <button style={styles.sixthSection.col1.btn}>200 USD</button>
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
            <img src={membership} alt="membresia" />
          </Col>
        </Row>

        <img
          src={dashboard}
          alt="opis dashboard mvp"
          style={{ width: "100%", maxWidth: "1100px" }}
        />
      </section>
    </div>
  );
}

export default Radium(SignedOut);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 767px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
};

const styles = {
  header: {
    padding: "8px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 1px 5px 0 rgba(0, 0, 0, 0.2)",
    backgroundColor: "white",
    ul: {
      margin: 0,
      padding: 0,
      display: "flex",
      gridGap: "24px",
      [query.md]: { display: "none" },
      li: { fontSize: "16px", fontWeight: 600, color: "#2B3674", cursor: "pointer" },
    },
    container: {
      display: "flex",
      alignItems: "center",
      gridGap: "16px",
      [query.md]: { display: "none" },
      input: {
        border: "1px solid #78d504",
        borderRadius: "25px",
        textAlign: "center",
        fontSize: "16px",
        width: "fit-content",
        outline: "1px solid #78d504",
        ":focus-visible": { outline: "1px solid #2ed82e" },
      },
      btnWeb3: {
        color: "white",
        backgroundColor: "#78d504",
        border: "0px solid transparent",
        fontSize: "16px",
        fontWeight: "600",
        padding: "8px 24px",
        borderRadius: "16px",
      },
    },
    mobileSection: { display: "none", [query.md]: { display: "flex" } },
  },
  marginTop: "16px",
  padding: "0 16px",
  maxWidth: "1100px",
  [query.sm]: { padding: "0 8px" },
  firstSection: {
    marginBottom: "64px",
    padding: "0 16px",
    h1: {
      fontSize: "40px",
      fontWeight: "600",
      color: "#2b3674",
      span: {
        background: "-webkit-linear-gradient(rgb(120, 213, 4), rgba(142, 255, 0, 0.7))",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        marginBottom: "-25px",
      },
    },
    success: { color: "green", margin: 0 },
    error: { color: "red", margin: 0 },
    form: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      input: {
        border: "1px solid #78d504",
        padding: "8px 24px 8px 16px",
        borderRadius: "25px",
        textAlign: "center",
        fontSize: "16px",
        width: "fit-content",
        outline: "1px solid #78d504",
        ":focus-visible": { outline: "1px solid #2ed82e" },
      },
      button: {
        color: "white",
        backgroundColor: "#78d504",
        border: "1px solid #78d504",
        fontSize: "16px",
        fontWeight: "600",
        padding: "8px",
        borderRadius: "16px",
        marginLeft: "-30px",
      },
    },
    p: { margin: "8px", fontSize: "16px" },
    metamask: {
      color: "white",
      backgroundColor: "#78d504",
      border: "1px solid #78d504",
      fontSize: "16px",
      fontWeight: "600",
      padding: "8px 16px",
      borderRadius: "16px",
    },
  },
  secondSection: {
    marginBottom: "64px",
    display: "grid",
    justifyItems: "center",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gridGap: "16px",
    imgContainer: {
      display: "grid",
      alignContent: "center",
      justifyContent: "center",
      border: "1px solid #78d504",
      borderRadius: "20px",
      width: "180px",
      height: "120px",
      img: { minWidth: "40px", objectFit: "contain" },
    },
  },
  thirdSection: {
    marginBottom: "64px",
    col1: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      h1: {
        fontSize: "40px",
        fontWeight: "600",
        color: "#2b3674",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        marginBottom: "8px",
        span: {
          background: "-webkit-linear-gradient(rgb(120, 213, 4), rgba(142, 255, 0, 0.7))",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "-25px",
        },
      },
      p: {
        fontSize: "20px",
        color: "rgba(42, 54, 116, 0.8)",
        textAlign: "left",
        span: {
          background: "-webkit-linear-gradient(rgb(120, 213, 4), rgba(142, 255, 0, 0.7))",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: 600,
        },
      },
      btn: {
        color: "white",
        backgroundColor: "#78d504",
        border: "0px solid transparent",
        fontSize: "16px",
        fontWeight: "600",
        padding: "4px 24px",
        borderRadius: "25px",
        display: "flex",
        alignItems: "center",
        gridGap: "8px",
        marginBottom: "20px",
        [query.md]: { alignSelf: "center" },
      },
      links: {
        display: "flex",
        gridGap: "16px",
        [query.md]: { alignSelf: "center", marginBottom: "40px" },
      },
    },
    col2: {
      display: "grid",
      justifyContent: "center",
      alignContent: "center",
      div: { display: "flex", flexDirection: "column", gridGap: "24px" },
    },
  },
  fourthSection: {
    marginBottom: "64px",
    col2: {
      h1: {
        fontSize: "40px",
        fontWeight: "600",
        color: "#2b3674",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        marginBottom: 0,
        span: {
          background: "-webkit-linear-gradient(rgb(120, 213, 4), rgba(142, 255, 0, 0.7))",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "-25px",
        },
      },
      p: { fontSize: "20px", color: "rgba(42, 54, 116, 0.8)", textAlign: "left" },
    },
  },
  fifthSection: {
    marginBottom: "64px",
    maxWidth: "1200px",
    h1: {
      fontSize: "40px",
      fontWeight: "600",
      color: "#2b3674",
      textAlign: "left",
      span: {
        background: "-webkit-linear-gradient(rgb(120, 213, 4), rgba(142, 255, 0, 0.7))",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        marginBottom: "-25px",
      },
    },
    col1: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gridGap: "16px",
      padding: "16px",
      h2: {
        fontSize: "28px",
        fontWeight: "600",
        color: "#2b3674",
        marginBottom: 0,
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        span: {
          background: "-webkit-linear-gradient(rgb(120, 213, 4), rgba(142, 255, 0, 0.7))",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginTop: "-20px",
        },
      },
      section: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        "::before": {
          content: "|",
          color: "black",
        },
        img: {
          backgroundColor: "#F6F8FD",
          borderRadius: "25px",
          width: "50px",
          height: "50px",
          padding: "16px",
          marginRight: "16px",
        },
        p: {
          fontSize: "16px",
          fontWeight: 600,
          color: "rgb(43, 54, 116)",
          margin: 0,
        },
        span: { color: "#A3AED0", maxWidth: "200px", textAlign: "left" },
      },
    },
  },
  sixthSection: {
    maxWidth: "776px",
    col1: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      h1: {
        fontSize: "40px",
        fontWeight: "600",
        color: "#2b3674",
        marginBottom: 0,
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        span: {
          background: "-webkit-linear-gradient(rgb(120, 213, 4), rgba(142, 255, 0, 0.7))",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginTop: "-25px",
          fontWeight: 800,
        },
      },
      p: { textAlign: "left", fontSize: "16px", color: "#A3AED0", span: { fontWeight: 600 } },
      btn: {
        color: "white",
        backgroundColor: "#78d504",
        border: "0px solid transparent",
        fontSize: "16px",
        fontWeight: "600",
        padding: "8px 32px",
        borderRadius: "25px",
        display: "flex",
        alignItems: "center",
        gridGap: "8px",
        marginBottom: "20px",
      },
    },
  },

  premiumPlan: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    plan: {
      background: "linear-gradient(90deg, rgba(120,213,4,1) 0%, rgba(34,177,105,1) 100%)",
      color: "white",
      borderRadius: "16px",
      padding: "16px",
      maxWidth: "380px",
      width: "100%",
      div: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        h3: { fontSize: "22px", fontWeight: 600, color: "white", margin: 0 },
        p: { fontSize: "16px", margin: 0, span: { fontSize: "22px", fontWeight: 600 } },
      },
    },
    p: { fontSize: "16px", textAlign: "left", margin: "8px 0" },
    section: {
      display: "flex",
      img: {
        backgroundColor: "#F6F8FD",
        borderRadius: "25px",
        width: "50px",
        height: "50px",
        padding: "16px",
        marginRight: "16px",
      },
      div: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        p: {
          fontSize: "16px",
          fontWeight: 600,
          color: "rgb(43, 54, 116)",
          margin: 0,
        },
        span: { color: "#A3AED0", maxWidth: "200px", textAlign: "left" },
      },
    },
    itemsContainer: {
      display: "flex",
      flexDirection: "column",
      gridGap: "16px",
      width: "100%",
    },
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    container: {
      display: "flex",
      img: {
        backgroundColor: "#F6F8FD",
        borderRadius: "25px",
        width: "50px",
        height: "50px",
        padding: "16px",
        marginRight: "16px",
      },
      imgFree: { marginRight: "16px" },
      div: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        p: {
          fontSize: "16px",
          fontWeight: 600,
          color: "rgb(43, 54, 116)",
          margin: 0,
          textAlign: "left",
        },
        span: { color: "#A3AED0", maxWidth: "200px", textAlign: "left" },
      },
    },
    discount: {
      color: "#2b3674",
      p: {
        fontSize: "20px",
        fontWeight: 600,
        textAlign: "right",
        margin: 0,
        display: "flex",
        flexDirection: "column",
        span: { color: "#78D504", marginTop: "-10px" },
      },
    },
  },
};
